module.exports = __webpack_public_path__ + "static/Managed-7254f8b6c6646ce990526384ff80e672.png";